export enum LocationType {
  Customer = 'CUSTOMER',
  Fleet = 'FLEET',
  Receiver = 'RECEIVER',
  CustomerReceiver = 'CUSTOMER_RECEIVER'
}
